// Fetch every row of a query past Supabase's 1000-row response cap (the cap
// applies regardless of .limit()). The first page carries an exact count, then
// the remaining pages load in parallel — a page-at-a-time loop pays a full
// round trip per 1000 rows (measured 1.4s vs 0.3s for a client's ~7.9k
// product_matches rows, 2.0s vs 0.6s for ~7k on-sale products).
//
// `makeQuery(withCount)` must return a fresh query each call (supabase query
// builders are single-use) with a stable .order(), or offset pages can skip
// or repeat rows. Pass `withCount` through to .select():
//   fetchAllPages((withCount) => supabase.from('t')
//     .select('a, b', withCount ? { count: 'exact' } : undefined)
//     .eq('x', y).order('id'))
//
// Don't use it for queries already near the statement timeout (e.g. full-day
// price_history scans): the count runs the filter a second time.
export const PAGE_SIZE = 1000;

export async function fetchAllPages(makeQuery) {
  const first = await makeQuery(true).range(0, PAGE_SIZE - 1);
  if (first.error) throw first.error;
  let rows = first.data || [];
  const total = first.count ?? rows.length;
  if (total > rows.length) {
    const pages = [];
    for (let from = PAGE_SIZE; from < total; from += PAGE_SIZE) {
      pages.push(makeQuery(false).range(from, from + PAGE_SIZE - 1));
    }
    const results = await Promise.all(pages);
    for (const r of results) {
      if (r.error) throw r.error;
      rows = rows.concat(r.data || []);
    }
  }
  return rows;
}
